import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiList = {
  styleOverrides: { root: { '--ListItem-gap': '16px' } },
} satisfies Components<Theme>['MuiList'];
